import { useSelector } from "react-redux";
import { RootReduxState } from "~/modules/app/components/ReduxProvider/types";
import { PlanTypes, UserStoreState } from "../store/types";
import { getHasApiAccess } from "../util/getHasApiAccess";

// // // //

/**
 * useUser
 * React Hook that exposes User redux state
 */
export function useUser(): UserStoreState & {
    isAdmin: boolean;
    isPaidPlan: boolean;
    hasApiAccess: boolean;
} {
    const { user, loading, isLoggedIn, error } = useSelector(
        (state: RootReduxState) => state.user,
    );

    const isAdmin = user.role === "SUPERADMIN";

    // NOTE - we'll soon need more granular plan types exposed by this hook
    const isPaidPlan: boolean =
        [
            PlanTypes.PREMIUM_STARTER,
            PlanTypes.PREMIUM_ALL_ACCESS,
            PlanTypes.PREMIUM_DATA_DOWNLOADS,
            PlanTypes.TRIAL_STARTER,
            PlanTypes.TRIAL_ALL_ACCESS,
            PlanTypes.TRIAL_DATA_DOWNLOADS,
            PlanTypes.PREMIUM_ACADEMIC,
        ].includes(user?.organization.plan.type) ?? false;

    // Define a boolean that checks if the user has API access
    const hasApiAccess: boolean = getHasApiAccess(user?.organization.plan.type);

    return {
        user,
        loading,
        isLoggedIn,
        error,
        isAdmin,
        isPaidPlan,
        hasApiAccess,
    };
}
